(() => {
  const selectors = {
    bar: '[data-product-sticky-atc]',
    button: '[data-product-sticky-submit]',
    buttonText: '[data-product-sticky-submit-text]',
    price: '[data-product-sticky-price]',
  };

  const getMainSubmit = (sectionId) => document.getElementById(`ProductSubmitButton-${sectionId}`);
  const getMainPrice = (sectionId) => document.getElementById(`price-${sectionId}`);

  const getCleanPriceText = (priceElement) => {
    if (!priceElement) return '';

    const regularPrice = priceElement.querySelector('.price__regular .price-item--regular');
    const salePrice = priceElement.querySelector('.price__sale .price-item--sale');
    const fallbackPrice = priceElement.querySelector('.price-item');

    return (salePrice || regularPrice || fallbackPrice)?.textContent.trim() || '';
  };

  const syncStickyButton = (bar) => {
    const sectionId = bar.dataset.sectionId;
    const stickyButton = bar.querySelector(selectors.button);
    const stickyButtonText = bar.querySelector(selectors.buttonText);
    const stickyPrice = bar.querySelector(selectors.price);
    const mainSubmit = getMainSubmit(sectionId);
    const mainPrice = getMainPrice(sectionId);

    if (!stickyButton || !stickyButtonText || !mainSubmit) return;

    const mainSubmitText = mainSubmit.querySelector('span')?.textContent.trim();

    stickyButton.disabled = mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true';
    if (mainSubmitText) stickyButtonText.textContent = mainSubmitText;

    if (stickyPrice) {
      const priceText = getCleanPriceText(mainPrice);
      if (priceText) stickyPrice.textContent = priceText;
    }
  };

  const initStickyAtc = (bar) => {
    const sectionId = bar.dataset.sectionId;
    const productFormId = bar.dataset.productFormId;
    const stickyButton = bar.querySelector(selectors.button);
    const mainSubmit = getMainSubmit(sectionId);
    const productForm = document.getElementById(productFormId);

    if (!sectionId || !productFormId || !stickyButton || !mainSubmit || !productForm) return;
    if (bar.dataset.productStickyBound === 'true') return;

    bar.dataset.productStickyBound = 'true';
    syncStickyButton(bar);

    stickyButton.addEventListener('click', () => {
      syncStickyButton(bar);
      if (stickyButton.disabled) return;

      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit(mainSubmit);
      } else {
        mainSubmit.click();
      }
    });

    const setVisibility = (isMainButtonVisible) => {
      bar.classList.toggle('is-visible', !isMainButtonVisible);
      bar.setAttribute('aria-hidden', String(isMainButtonVisible));
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setVisibility(entry.isIntersecting);
        },
        { threshold: 0.15 }
      );

      observer.observe(mainSubmit);
    } else {
      setVisibility(false);
    }

    const syncObserver = new MutationObserver(() => syncStickyButton(bar));
    syncObserver.observe(mainSubmit, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    const mainPrice = getMainPrice(sectionId);
    if (mainPrice) {
      syncObserver.observe(mainPrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  };

  const initAllStickyAtc = () => {
    document.querySelectorAll(selectors.bar).forEach(initStickyAtc);
  };

  document.addEventListener('DOMContentLoaded', initAllStickyAtc);
  document.addEventListener('shopify:section:load', initAllStickyAtc);
})();
